import React from 'react';
import { Layout, Divider, Button } from 'antd';
import WidthWrapper from '../constants/WidthWrapper';
import './index.less';

export default () => {
  // 查看营业资质
  const handleCheckLicense = () => {
    window.open(`${process.env.TARGET}license`);
  };

  return (
    <WidthWrapper className="footer-location" scale fullscreen>
      <Layout.Footer className="copyright">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          Copyright ©2016-{new Date().getFullYear()} 浙江东明不锈钢制品股份有限公司 All rights
          reserved
          <Divider type="vertical" />
          <a href="http://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
            浙ICP备11061477号
          </a>
          <Divider type="vertical" />
          <img
            style={{ verticalAlign: 'top' }}
            src={`${process.env.TARGET}static/imgs/gnba.png`}
            alt=""
          />
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33049802000236"
            rel="noopener noreferrer"
          >
            浙公网安备 33049802000236号
          </a>
          <img
            alt=""
            src={`${process.env.TARGET}static/logos/license.jpg`}
            style={{ width: 26, height: 26, verticalAlign: 'top', marginLeft: '4px' }}
          />
          <Button size="small" onClick={handleCheckLicense}>
            查看营业资质
          </Button>
        </div>
      </Layout.Footer>
    </WidthWrapper>
  );
};
